import { ValidationTranslation } from '@/assets/locales/validation/validation.translation.en.ts';

export const validationTranslation: ValidationTranslation = {
  charactersLimit: 'Maksymalna liczba znaków to {{noOfChars}}',
  date: {
    maxCurrentDate: 'Data nie może być w przyszłości',
    maxDate: 'Data nie może być późniejsza niż {{maxDate}}',
    minCurrentDate: 'Data nie może być w przeszłości',
    notEarlierThen: '{{to}} nie może być wcześniejsze niż {{from}}',
  },
  email: 'Nieprawidłowy adres e-mail',
  general: {
    required: 'To pole jest wymagane',
    wrongFormat: 'Podano nieprawidłowy format',
  },
  iban: 'Numer IBAN jest nieprawidłowy',
  incorrectFileExtension:
    'Nieprawidłowe rozszerzenie pliku. Obsługiwane rozszerzenia: {{correctExtensions}}',
  integerNumber: 'Pole musi być liczbą całkowitą',
  isNumber: 'To pole musi być liczbą',
  length: 'Pole musi mieć {{length}} znaków',
  max: 'Maksymalna wartość to {{howMany}}',
  maxLength: 'Pole musi mieć maksymalnie {{max}} znaków',
  maxLengthOfMessage: 'Maksymalna długość wiadomości to {{max}} znaków',
  maxStringLength: 'Maksymalna długość dla tego pola to: {{max}}',
  min: 'Minimalna wartość to {{howMany}}',
  minLength: 'Pole musi mieć co najmniej {{min}} znaków',
  minNumber: 'Minimalna wartość dla tego pola to: {{minNumber}}',
  minStringLength: 'Minimalna długość dla tego pola to: {{min}}',
  mobile: 'Numer telefonu jest nieprawidłowy - dozwolone są tylko plus (+), myślniki (-) i cyfry',
  nip: 'Nieprawidłowa wartość NIP',
  noResults: 'Brak wyników',
  passwordMustMatch: 'Hasła muszą być zgodne',
  passwordRequirements:
    'Hasła muszą zawierać jedną cyfrę, jedną małą literę, jedną wielką literę i jeden znak specjalny. Długość hasła musi wynosić od 8 do 100 znaków.',
  pesel: 'Nieprawidłowy numer PESEL',
  phone: 'Numer telefonu jest nieprawidłowy (XXX-XXX-XXX)',
  pinsMustMatch: 'Kody PIN muszą być zgodne',
  rating: 'Proszę wybrać ocenę',
  regon: 'Nieprawidłowa wartość REGON',
  required: 'To pole jest wymagane',
  sameFileUploadError: 'Nie można przesłać tego samego pliku ponownie',
  stringLength: 'To pole musi mieć {{length}} znaków',
  tooLargeFileSize: 'Rozmiar pliku jest za duży. Maksymalny rozmiar pliku to: {{maxFileSize}}',
};
